import type { Clue, PlayerId, PuzzleInstance, Role } from '../types.ts';
import { shown, type PuzzlePlayer } from './types.ts';

/** Ids of the players with one of the given roles. */
export function playersWithRole(players: readonly PuzzlePlayer[], ...roles: Role[]): PlayerId[] {
  return players.filter((p) => roles.includes(p.role)).map((p) => p.id);
}

/** The clues `role` holds, as `kind → what is shown`. Tampered clues show their false value. */
export function holderClues(p: PuzzleInstance, role: Role): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const c of p.clues) if (c.holder === role) out[c.kind] = shown(c);
  return out;
}

export function clueByKind(p: PuzzleInstance, kind: string): Clue {
  const c = p.clues.find((x) => x.kind === kind);
  if (!c) throw new Error(`puzzle ${p.id} has no clue of kind ${kind}`);
  return c;
}

/** Clues that can still be altered (not already tampered) and are not held by `exclude`. */
export function alterableClues(p: PuzzleInstance, exclude: Role | null): Clue[] {
  return p.clues.filter((c) => !c.tampered && c.holder !== exclude);
}

export const inRange = (n: number, min: number, max: number): boolean =>
  Number.isInteger(n) && n >= min && n <= max;

/** Deep copy for JSON-shaped values. */
export function copy<T>(v: T): T {
  return structuredClone(v);
}
